<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_shippingMarkType') || '唛头类型'"
            prop="shippingMarkType"
          >
            <div>
              <el-radio-group v-model="formData.shippingMarkType">
                <el-radio-button label="T">
                  {{ $l('form_label_shippingMarkType_text') || '文本' }}
                </el-radio-button>
                <el-radio-button label="I">
                  {{ $l('form_label_shippingMarkType_image') || '图片' }}
                </el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_destinationPort') || '关联目的港口'"
          >
            <dict-select
              v-model="formData.destinationPort"
              url="/master/port/select"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_cust') || '关联客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_shippingMarkText') || '唛头文本'"
            ref="shippingMarkTextForm"
            prop="shippingMarkText"
          >
            <el-input
              v-model="formData.shippingMarkText"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_shippingMarkTextEn') || '唛头英文名称'"
            prop="nameEn"
          >
            <el-input
              v-model="formData.nameEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_shippingMarkImage') || '唛头图片'"
            required
            ref="shippingMarkImageForm"
            prop="shippingMarkImage"
          >
            <br />
            <MarkImage
              v-model="formData.shippingMarkImage"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import MarkImage from '../mark-image'
export default {
  mixins: [EditLoading],
  components: { MarkImage },
  props: {
    disabled: { type: Boolean, default: false },
    shippingMarkCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { shippingMarkType: 'T', shippingMarkImage: {} },
      backDialogVisible: false,
      rules: {
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        shippingMarkType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        shippingMarkText: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        shippingMarkImage: [
          {
            validator: (rule, value, callback) => {
              const { raw, shippingMarkImageUrl } = value || {}
              if (raw || shippingMarkImageUrl) {
                callback()
              } else {
                callback(
                  new Error(this.$l('INDEX.tips_select_data') || '请选择...')
                )
              }
            },
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.shippingMarkCode) return
      this.$api
        .shippingMarkDetailApi({
          shippingMarkCode: this.shippingMarkCode,
        })
        .then((res) => {
          const { body } = res || {}
          const data = body || {}
          this.formData = {
            ...data,
            shippingMarkImage: {
              shippingMarkImageUrl: data.shippingMarkImageUrl,
              shippingMarkImageFileCode: data.shippingMarkImageFileCode,
            },
          }
        })
    },
    async save() {
      if (!(await validate.formValidate([this.$refs.form]))) return

      const markImage = await this.fileHander(this.formData.shippingMarkImage)
      this.loadingOpen()
      const res = await this.$api
        .shippingMarkSaveApi({ ...this.formData, ...markImage })
        .catch(() => null)

      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$emit('close')
      this.$emit('reload')
    },
    async fileHander(file) {
      if (!file) return {}
      if (file.shippingMarkImageUrl) return file
      return await this.uploadFile(file)
    },
    uploadFile(readyFile) {
      if (!readyFile || !readyFile.raw) {
        return Promise.resolve({})
      }
      return this.$api.SYS_UPLOAD(readyFile.raw).then((res) => ({
        shippingMarkImageUrl: res.body.url,
        shippingMarkImageFileCode: res.body.fileId,
      }))
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
